import React from "react";
import Viewbanner from "../components/viewdetails/viewbanner/viewbanner";
import Aboutautored from "../components/viewdetails/aboutautored/aboutautored";
import Getintouch from "../components/viewdetails/getintouch/getintouch";
import Navbar from "../components/Global/Navbar/Navbar";

const Viewdetails = () => {
  return (
    <div>
      <Viewbanner />
      <Aboutautored />
      <Getintouch />
    </div>
  );
};

export default Viewdetails;
